export default "__VITE_ASSET__DquYe9qt__"